/**
 * @generated SignedSource<<e0f6d4ee2b68fa00fcc06e3c69f2e00e>>
 * @relayHash 1e11714ae08776671ab5c43bd95e63c2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7796a686a40381dc088a041f5845ef2b6be6d6e42cfc99dcf5219f541bd9ecec

import type { ConcreteRequest } from 'relay-runtime';
export type ContentAccessType = "EVERYONE_CAN_EDIT" | "EVERYONE_CAN_VIEW" | "EVERYONE_NO_ACCESS" | "%future added value";
export type useUsersContentPermissionsContentPermissionsQuery$variables = {
  accountIds: ReadonlyArray<string | null>;
  contentId: string;
};
export type useUsersContentPermissionsContentPermissionsQuery$data = {
  readonly contentPermissions: {
    readonly contentAccess: ContentAccessType;
    readonly subjectsWithEffectiveContentPermissions: {
      readonly nodes: ReadonlyArray<{
        readonly displayName: string | null;
        readonly id: string | null;
        readonly user: {
          readonly profilePicture: {
            readonly path: string;
          } | null;
        } | null;
      } | null> | null;
    };
  } | null;
  readonly usersWithContentRestrictions: ReadonlyArray<{
    readonly accountId: string | null;
    readonly displayName: string | null;
    readonly hasSpaceViewPermission: boolean | null;
    readonly profilePicture: {
      readonly path: string;
    } | null;
    readonly restrictingContent: {
      readonly hasRestrictions: boolean;
      readonly id: string | null;
    } | null;
  } | null> | null;
};
export type useUsersContentPermissionsContentPermissionsQuery = {
  response: useUsersContentPermissionsContentPermissionsQuery$data;
  variables: useUsersContentPermissionsContentPermissionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = {
  "kind": "Variable",
  "name": "contentId",
  "variableName": "contentId"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v4 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v5 = [
  {
    "args": [
      (v1/*: any*/)
    ],
    "concreteType": "ContentPermissions",
    "kind": "LinkedField",
    "name": "contentPermissions",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "contentAccess"
      },
      {
        "concreteType": "PaginatedSubjectUserOrGroupList",
        "kind": "LinkedField",
        "name": "subjectsWithEffectiveContentPermissions",
        "plural": false,
        "selections": [
          {
            "concreteType": "SubjectUserOrGroup",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "UserWithRestrictions",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v4/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "args": [
      {
        "kind": "Variable",
        "name": "accountIds",
        "variableName": "accountIds"
      },
      (v1/*: any*/)
    ],
    "concreteType": "UserWithRestrictions",
    "kind": "LinkedField",
    "name": "usersWithContentRestrictions",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "hasSpaceViewPermission"
      },
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "restrictingContent",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "name": "hasRestrictions"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "accountId"
      },
      (v3/*: any*/),
      (v4/*: any*/)
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useUsersContentPermissionsContentPermissionsQuery",
    "selections": (v5/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUsersContentPermissionsContentPermissionsQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "1e11714ae08776671ab5c43bd95e63c2",
    "id": "7796a686a40381dc088a041f5845ef2b6be6d6e42cfc99dcf5219f541bd9ecec",
    "metadata": {},
    "name": "useUsersContentPermissionsContentPermissionsQuery",
    "operationKind": "query",
    "text": "query useUsersContentPermissionsContentPermissionsQuery($accountIds:[String]!,$contentId:ID!){contentPermissions(contentId:$contentId){contentAccess,subjectsWithEffectiveContentPermissions{nodes{id,displayName,user{profilePicture{path}}}}},usersWithContentRestrictions(accountIds:$accountIds,contentId:$contentId){hasSpaceViewPermission,restrictingContent{id,hasRestrictions},accountId,displayName,profilePicture{path}}}"
  }
};
})();

(node as any).hash = "17ce6feb201fcfab95a8a2ed98133b5c";

export default node;
